export default __webpack_public_path__ + "static/media/what-we-do-background.6e72a4b4.png";